export default {
    meta: {
        title: '加盟商管理列表',
        url: '/standardstore/franchiseelist',
        urlName: '标准版加盟商管理',
    }
};
